import { render, staticRenderFns } from "./organisation.vue?vue&type=template&id=6d0f28c5&scoped=true&"
import script from "./organisation.vue?vue&type=script&lang=js&"
export * from "./organisation.vue?vue&type=script&lang=js&"
import style0 from "./organisation.vue?vue&type=style&index=0&id=6d0f28c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0f28c5",
  null
  
)

export default component.exports